import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { ParentsFeedbackRoutingModule } from './parents-feedback-routing.module';
import { ParentsFeedbackListComponent } from './parents-feedback-list/parents-feedback-list.component';
import { ParentsFeedbackViewComponent } from './parents-feedback-view/parents-feedback-view.component';

@NgModule({
  declarations: [ParentsFeedbackListComponent, ParentsFeedbackViewComponent],
  imports: [
    CommonModule,
    ParentsFeedbackRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class ParentsFeedbackModule { }
